<div class="modal-content help-support-modal">
  <div class="help-support-modal__header">
    <button class="help-support-modal__close" tabindex="0" (click)="closeModal('credit-card-help-support-modal')">
      <img src="assets/icons/xmark-solid.svg" alt="" aria-hidden="true" />
      {{ 'close' | translate }}
    </button>
  </div>

  <div class="help-support-modal__body">
    <h1 class="help-support-modal__title">{{ 'credit-card-help-support-modal-title' | translate }}</h1>
    <div class="separator-line"></div>

    <h2 class="help-support-modal__subtitle">{{ 'credit-card-help-support-modal-subtitle' | translate }}</h2>
    <p class="help-support-modal__description">{{ 'credit-card-help-support-modal-description' | translate }}</p>

    <div class="help-support-card">
      <img class="help-support-card__icon" src="assets/icons/staff.svg" alt="" aria-hidden="true" />
      <div class="help-support-card__content">
        <h3 class="help-support-card__title">{{ 'credit-card-help-support-modal-card-staff-title' | translate }}</h3>
        <p class="help-support-card__text">{{ 'credit-card-help-support-modal-card-staff-text' | translate }}</p>
      </div>
    </div>

    <div class="help-support-card">
      <img class="help-support-card__icon" src="assets/icons/phone.svg" alt="" aria-hidden="true" />
      <div class="help-support-card__content">
        <h3 class="help-support-card__title">{{ 'credit-card-help-support-modal-card-location-title' | translate }}</h3>
        <p class="help-support-card__text">
          {{ 'credit-card-help-support-modal-card-location-line-1' | translate }}<br />
          {{ 'credit-card-help-support-modal-card-location-line-2' | translate }}
        </p>
        <a class="help-support-card__phone" [href]="'tel:' + (rentalPhoneNumberLink || ('footer-customer-support-phone-number' | translate))">
          {{ rentalPhoneNumber || ('footer-customer-support-phone-number' | translate) }}
        </a>
      </div>
    </div>
  </div>
</div>
